module.exports = __webpack_public_path__ + "static/media/998103.9adfc2a7.png";